export { default } from './CicDisclosureDetails';
